import React from 'react'
import classnames from 'classnames'
import { contactFinField, homeLink } from './Contact.module.scss'
import { ArrowRight } from '../../ui/Icon'
import { InternalLink } from '../../ui/Link'

export const ContactFin = () => {
	return (
		<div className={contactFinField}>
			<h2 className="text-base lg:text-2xl font-bold text-center">
				この度は、お問い合わせいただきまして
				<br />
				誠にありがとうございます。
			</h2>
			<p className="mt-10 text-sm leading-6">
				内容確認後、担当より通常1〜3営業日以内にご連絡いたします。
				土日祝日前後、年末年始等に関してはご連絡が遅れる場合がございます。
			</p>
			<p className="relative pl-4 mt-5 text-xs leading-5">
				<span className="absolute top-0 left-0 p-0.5">※</span>
				なお、ご入力いただいたメールアドレス宛に受付完了メールを自動送信しております。
				届かない場合、迷惑メールフォルダに入っている、メールアドレスを間違えているなどの可能性がありますのでご確認ください。
			</p>
			<InternalLink
				href="/"
				className={classnames(homeLink, 'flex relative z-30 justify-between items-center mx-auto mt-10 lg:mt-14')}
			>
				<span className="z-10 text-sm">TOPに戻る</span>
				<ArrowRight />
			</InternalLink>
		</div>
	)
}
